import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import ViewIcon from "components/CustomIcons/View.js";
import EmailIcon from "components/CustomIcons/Email.js";

import { Visibility, CreditCard } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";
import EmailView from "@material-ui/icons/Email";

import { Tooltip } from "@material-ui/core";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomModal from "components/CustomModal/Modal.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import { getPoliciesByAgent } from "views/Services/OrdersService";
import { sendEmailAgent } from "views/Services/ClientService";

import MenuButton from "components/MenuButton/MenuButton.js";

import {
  checkIfIsKiosko,
  sanatizeMessageHtml,
} from "components/Utils/utils.js";
import environment from "../../environment/environment";
import { useTranslation } from "react-i18next";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
export default function Dashboard() {
  const wizardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  const isInactive = useInactivity();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const [totalRows, setTotalRows] = useState(0);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [isAgent, setIsAgent] = useState(false);
  const [allPolicies, setAllPolicies] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [isOpenErrors, setIsOpenErrors] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [currentOrderId, setCurrentOrderId] = useState(0);
  const [currentName, setCurrentName] = useState("");
  const [csrEmail, setCsrEmail] = useState("");
  const [loading, setLoading] = React.useState(false);
  const rowsForPage = 10;

  useEffect(() => {
    getPolicies(currentOffset);
  }, [dispatch, isAgent, allPolicies]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setOrdenes([]);
      handleChangePage(0);
      goToFirstPage();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const tableRef = useRef();

  const goToFirstPage = () => {
    tableRef.current.resetPage(0);
  };

  const goNext = () => {
    tableRef.current.nextPage();
  };

  const getPolicies = async (offset) => {
    setLoading(true);
    const data = {
      start: offset,
      length: 50,
      agent: isAgent,
      allyears: allPolicies,
      search: {
        value: search,
        regex: false,
      },
    };

    const resultSubmit = await dispatch(getPoliciesByAgent(data));
    setOrdenes(resultSubmit.payload.data.data);
    setTotalRows(resultSubmit.payload.data.recordsTotal);
    setCurrentOffset(offset);
    setLoading(false);
  };

  const closeModal = () => {
    setIsOpenErrors(false);
    setCurrentName("");
    setCurrentOrderId(0);
    setCsrEmail("");
    setEmail("");
  };

  const sendEmail = async () => {
    const data = {
      orderid: currentOrderId,
      email: email,
      csr_email: csrEmail,
      uri: "/guest/summary/" + currentOrderId,
      to_name: currentName,
    };

    const resultSubmit = await dispatch(sendEmailAgent(data));
    setMessageToast(resultSubmit.payload.message);
    console.log(resultSubmit.payload.result);
    if (resultSubmit.payload.result) {
      closeModal();
      setModalSuccess(true);
    }
  };

  const setMyPolicies = () => {
    setAllPolicies(false);
    setIsAgent(true);
  };
  const setPolicies = () => {
    setAllPolicies(false);
    setIsAgent(false);
  };
  const setAllYearsMyPolicies = () => {
    setAllPolicies(true);
    setIsAgent(true);
  };
  const setAllYearsAllPolicies = () => {
    setAllPolicies(true);
    setIsAgent(false);
  };
  const classes = useStyles();

  // Hooks
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const url = redesign === "true" ? "/guestRedesing" : "/admin/wizard";

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === "search") {
      setSearch(value);
    }
    if (name === "email") {
      setSearch(value);
    }
    if (name === "csr") {
      setCsrEmail(value);
    }
  };

  const fillButtons = (order) => {
    const styleButton = {
      cursor: "pointer",
      padding: "0px !important",
    };
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/guest/summary/${order.order_id}`)}
            md={2}
            style={styleButton}
          >
            <Tooltip title="View Policy" placement="top" arrow>
              <Visibility
                style={{ color: "#13816F" }}
                fontSize="small"
              ></Visibility>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => {
              window.open(`/admin/policyPdf/policy/${order.policy_nbr}`);
            }}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Download Pdf Policy" placement="top" arrow>
              <DescriptionIcon
                style={{ color: "#13816F" }}
                fontSize="small"
              ></DescriptionIcon>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => {
              window.open(`/admin/policyPdf/card/${order.policy_nbr}`);
            }}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Download Pdf Card" placement="top" arrow>
              <CreditCard
                style={{ color: "#13816F" }}
                fontSize="small"
              ></CreditCard>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => {
              setCurrentOrderId(order.order_id);
              setCurrentName(order.first_name + " " + order.last_name);
              setEmail(order.email);
              setIsOpenErrors(true);
            }}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Send Email" placement="top" arrow>
              <EmailView
                style={{ color: "#13816F" }}
                fontSize="small"
              ></EmailView>
            </Tooltip>
          </GridItem>
        </GridContainer>
      </>
    );
  };

  const calculateExpirationText = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      let newDateExpiration = orderExpirationDate.split("-");
      const fechaActual = new Date();
      const fechaExpiracion = new Date(
        newDateExpiration[2] +
          "-" +
          newDateExpiration[0] +
          "-" +
          newDateExpiration[1]
      );
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias < 0) {
        return "Expired";
      } else {
        return "Active";
      }
    }
  };
  const handleChangePage = (currentPage) => {
    if ((currentPage * rowsForPage) % 50 === 0) {
      getPolicies(currentPage * rowsForPage);
    }
  };

  const getDataStatus = (status) => {
    if (status.search("OK") !== -1) {
      return { name: "Active", color: classes.success };
    }
    if (status.search("Expired") !== -1) {
      return { name: "Expired", color: classes.danger };
    }
    if (status.search("Cancelled") !== -1) {
      return { name: "Cancelled", color: classes.warning };
    }
    return { name: "None", color: classes.info };
  }

  const getActivePolicies = () => {
    let ordenesT = [];
    let daysLeft = 0;
    ordenes.forEach((order, index) => {
      const statusData = getDataStatus(order.active);
      const rowIndex = currentOffset + index + 1;
      ordenesT[rowIndex] = [
        order.policy_nbr || "",
        {
          name: order.dl_number || "",
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.last_name || "",
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.first_name || "",
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.year_model || "",
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.make || "",
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.model || "",
          className: isXs || isSm ? classes.displayNone : "",
        },
        order.issue_date || "",
        {
          name: order.effective_date || "",
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.expiration_date || "",
          className: isXs || isSm ? classes.displayNone : "",
        },
        <span
          className={`${classes.badge} ${
            statusData.color || classes.info
          }`}
        >
          {statusData.name}
        </span>,
        fillButtons(order),
      ];
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                ref={tableRef}
                tableHead={[
                  t("policies.policyNumber"),
                  {
                    name: t("policies.dlNumber"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.lastName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.firstName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.year"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.make"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.model"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("policies.issueData"),
                  {
                    name: t("policies.effectiveData"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.expirationDate"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("policies.status"),
                  t("policies.options"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
                rowsPerPage={10}
                totalRows={totalRows}
                changePage={handleChangePage}
                loading={loading}
              />

              <CustomModal
                title="Send Email"
                isOpen={isOpenErrors}
                onClose={closeModal}
                privacy={false}
                id={"emailModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <p style={{ color: "red" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanatizeMessageHtml(messageToast),
                        }}
                      ></div>
                    </p>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={1}></GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step2.email")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "email",
                        id: "email",
                        value: email,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step4.csrInitials")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "csr",
                        id: "csr",
                        value: csrEmail,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="sendEmail"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            sendEmail();
                          }}
                          block
                        >
                          Send
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
              <CustomModal
                title="Success"
                isOpen={modalSuccess}
                onClose={() => {
                  setModalSuccess(false);
                  setMessageToast("");
                }}
                privacy={false}
                id={"successModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <h4>{messageToast}</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="successButton"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            setModalSuccess(false);
                            setMessageToast("");
                          }}
                          block
                        >
                          Ok
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };

  const gridPolicies = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={12}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("policies.title")}{" "}
                        </div>
                        <GridContainer>
                          {ordenes && (
                            <>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() => setAllYearsAllPolicies()}
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t(
                                        "policies.buttons.allYearsAllPolicies"
                                      )}
                                    </Button>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() => setAllYearsMyPolicies()}
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t("policies.buttons.allYearsMyPolicies")}
                                    </Button>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() => setPolicies()}
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t("policies.buttons.allPolicies")}
                                    </Button>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                      id="continueMobile"
                                      onClick={() => setMyPolicies()}
                                      style={{ backgroundColor: "#008670" }}
                                      block
                                    >
                                      {t("policies.buttons.myPolicies")}
                                    </Button>
                                  </GridItem>
                                </GridContainer>
                              </GridItem>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                <GridContainer>
                                  <GridItem xs={0} sm={0} md={9}></GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <CustomInput
                                      labelText={t("step2.search")}
                                      formControlProps={{
                                        fullWidth: true,
                                        className:
                                          classes.customFormControlClasses,
                                      }}
                                      inputProps={{
                                        name: "search",
                                        id: "search",
                                        value: search,
                                        onChange: handleFormChange,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              </GridItem>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                {getActivePolicies()}
                              </GridItem>
                            </>
                          )}
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  return <>{gridPolicies()}</>;
}
